import React from 'react';

import {
	useClassNames,
} from '@common';

import './Checkbox.scss';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string,
	className?: string,
	defaultBoolValue?: boolean,
	boolValue?: boolean,
	onValueChange?: (newValue: boolean) => void
}

function Checkbox(props: CheckboxProps): JSX.Element {
	const {
		className,
		label,
		// defaultBoolValue,
		boolValue,
		onValueChange
	} = props;

	const classes = useClassNames(
		'checkbox',
		className,
	);

	const onInputChange = (ev) => {
		if (onValueChange) {
			onValueChange(ev.target.checked ? true : false);
		}
	}

	return (
		<div className={classes}>
			<input
				className="checkbox__input"
				name={label}
				id={label}
				type="checkbox"
				// defaultChecked={defaultBoolValue}
				checked={boolValue}
				onChange={onInputChange}
			/>
			{label && <label htmlFor={label} className="checkbox__label"> {label}</label>}
		</div>
	);
}

const MemoisedCheckbox = React.memo(Checkbox);

export {MemoisedCheckbox as Checkbox};